<template>
  <div>
    <div class="parent">
      <v-card>
        <v-card-title class="info-title">
          <div class="text-center text-padding">
            سطح {{ item.Sath }} {{ item.StrState ? ` - ${item.StrState}` : "" }}
          </div>
        </v-card-title>

        <div>
          <app-row icon="hashtag" title="شماره:" :value="item.DiplomId" />
          <app-row icon="book" title="رشته:" :value="item.Field" />
          <app-row
            icon="building"
            title="صادر کننده:"
            :value="item.SchoolName"
          />
          <app-row icon="hashtag" title="معدل:" :value="item.Average" />
          <app-row
            icon="calendar-alt"
            title="تاریخ اتمام:"
            :value="item.DiplomaDate"
          />
          <app-row
            icon="calendar-alt"
            title="تاریخ صدور:"
            :value="item.SodoorDate"
          />
          <!-- <v-row align="center">
            <v-col id="buttonRow">
              <app-status
                :item="item"
                @showPostRequestForm="handleShowPostRequstForm(item)"
              />
            </v-col>
          </v-row> -->
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
import { PostRequestStep_Enum, PostRequestState_Enum } from "@/utils/constants";
import StatusButton from "./StatusButton.vue";
export default {
  props: ["item", "index", "selectedItem"],
  components: {
    appStatus: StatusButton,
    appRow: DetailRow,
  },
  data() {
    return {
      PostRequestState_Enum: PostRequestState_Enum,
    };
  },
  methods: {
    handleShowPostRequstForm(item) {
      this.$emit("showPostRequestForm", item);
    },
  },
  computed: {
    selected() {
      return this.selectedItem == this.index;
    },
    dateRange() {
      return "از " + this.item.AzTarikh + " تا " + this.item.TaTarikh;
    },
  },
};
</script>
<style scoped>
.register {
  margin: 20px 20px 0 20px !important;
}
</style>
